import useOnboardingStep from 'hooks/useOnboardingStep';
import { OnboardingStep } from 'modules/types/util';
import React, { useState } from 'react';
import { ButtonWrapper } from 'shared/components/AccountMenu/AccountMenu.styles';
import Button from 'shared/components/Button/Button';
import TasksIcon from 'shared/components/icons/TasksIcon';
import InfoDrawer from 'shared/components/InfoDrawer/InfoDrawer';
import { useTranslation } from 'react-i18next';
import { OnboardingNav } from './OnboardingNav';

export function OnboardingNavDrawer() {
  const { t } = useTranslation('translation', { keyPrefix: 'status.prePto' });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { completedSubtasks } = useOnboardingStep();
  const tasksIcon = () => <TasksIcon hasAlert={!completedSubtasks.has(OnboardingStep.TPV)} />;

  return (
    <>
      <ButtonWrapper>
        <Button
          styleVariant="tertiary"
          Icon={tasksIcon}
          label={t('tasks')}
          onClick={() => setIsOpen(true)}
        />
      </ButtonWrapper>
      <InfoDrawer
        title={t('tasks')}
        body={<OnboardingNav onClick={() => setIsOpen(false)} />}
        isOpen={isOpen}
        onCloseInfoDrawer={() => setIsOpen(false)}
      />
    </>
  );
}

export default OnboardingNavDrawer;
